export default ":host ::ng-deep .mat-form-field {\n  padding: 10px 16px 0;\n}";